// extracted by mini-css-extract-plugin
export default {"popularTags":"eiLdw","title":"CYVbr","tagsWrapper":"zWwty","tagItem":"FXcAf"};